import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Preview Email APIs
 */
class PreviewEmailApi extends ApiBase {
  /**
   *
   * @param {*} payload
   */
  deliveryTabPreview = async payload => {
    const request = {
      url: `${this.API_URL}/mail/preview/deliverytab`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(payload)
    };

    const response = await axios.request(request);

    return response.data;
  };

  /**
   *
   * @param {*} payload
   */
  contactPreview = async payload => {
    const request = {
      url: `${this.API_URL}/mail/preview/contact`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(payload)
    };

    const response = await axios.request(request);

    return response.data;
  };

  /**
   * Preview Email for a saved Distribution List
   * @param {*} subject Mail subject
   * @param {*} msgBody  Mail body
   * @param {*} userEmail User Email
   * @param {*} fundId Fund ID
   * @param {*} investorId Investor ID
   * @param {*} testEmail Test Email Y/N
   * @param {*} resourceUploadId Resource Upload ID
   */
  async previewforSavedDL(
    subject,
    msgBody,
    userEmail,
    fundId,
    investorId,
    testEmail,
    resourceUploadId
  ) {
    // Get common headers
    const headers = this.getHeaders();
    const request = {
      url: `${this.API_URL}/mail/preview/distributionlist`,
      method: 'POST',
      headers: headers,
      data: {
        subject,
        msgBody,
        fundId,
        investorId,
        userEmail,
        testEmail,
        resourceUploadId
      }
    };

    const response = await axios.request(request);
    return response.data;
  }
}
export default new PreviewEmailApi();
